// ═══════════════════════════════════════════════════════════════════════════════
// ▶  EDIT DATA DI SINI — Ganti semua teks sesuai informasi Anda
// ═══════════════════════════════════════════════════════════════════════════════
import fotoProfil from './assets/foto_jas.PNG';
export const DATA = {
  foto: fotoProfil,
  name: "Raka Adi Waluyo",
  title: "Embedded Systems Engineer",
  tagline: "Solving problems, one system at a time.",
  about:
      "I am a graduate of the Computer Systems study program at the Faculty of Computer Science and Information Technology, Gunadarma University, as well as a full academic scholarship recipient. My primary interest lies in the field of embedded systems, electronics, and microcontroller programming — particularly in the context of automation, Internet of Things (IoT), and robotics.\n\nThroughout my studies, I was actively involved in various laboratory practicum activities and technical projects, including the development of ESP32/ESP8266-based microcontroller systems for real-time monitoring and automation purposes. This experience was further strengthened by my role as an Assistant at the Multimedia and Robotics Laboratory of Gunadarma University, where I sharpened my technical skills, problem-solving abilities, and team collaboration in a structured environment.\n\nI have also been part of the Indonesian Robot Contest (KRI) team, gaining real hands-on experience in the design, development, and competitive implementation of robotic systems. With all of these experiences, I am ready to contribute and continue growing in the professional world — particularly in the fields of embedded systems, robotics, and intelligent system integration.",
  email: "rakaadiwaluyo036@gmail.com",
  phone: "+62 812-3456-7890",
  linkedin: "linkedin.com/in/Raka-adiwaluyo-19556430a",
  github: "github.com/Raka036",
  instagram: "instagram.com/raka_adi_waluyo_",
  location: "Depok, Jawa Barat, Indonesia",

  skills: [
    {
      category: "Hardware & Infrastructure",
      icon: "🖥️",
      items: ["PC Assembly & Repair", "Server Management", "Network Cabling", "Printer & Peripheral"],
    },
    {
      category: "Software & OS",
      icon: "💿",
      items: ["Windows Server 2019", "Linux (Ubuntu)", "Active Directory", "Microsoft 365"],
    },
    {
      category: "Networking",
      icon: "🌐",
      items: ["TCP/IP", "LAN/WAN", "VPN Setup", "Firewall Config"],
    },
    {
      category: "Tools & Support",
      icon: "🛠️",
      items: ["ServiceNow", "TeamViewer", "Remote Desktop", "Helpdesk Ticketing"],
    },
  ],

  projects: [
    {
      title: "Network Infrastructure Upgrade",
      description:
        "Upgrade jaringan kantor dari 100Mbps ke 1Gbps, termasuk konfigurasi switch, router, dan access point untuk 150+ workstation.",
      tech: ["Cisco", "VLAN", "VPN"],
      year: "2024",
      icon: "🔗",
    },
    {
      title: "Active Directory Implementation",
      description:
        "Implementasi AD untuk manajemen user, group policy, dan keamanan akses di perusahaan dengan 200+ karyawan.",
      tech: ["Windows Server", "AD", "GPO"],
      year: "2023",
      icon: "🗂️",
    },
    {
      title: "Helpdesk System Deployment",
      description:
        "Deployment sistem ticketing helpdesk yang berhasil memangkas rata-rata waktu resolusi masalah dari 3 hari menjadi 4 jam.",
      tech: ["ServiceNow", "SLA", "Reporting"],
      year: "2023",
      icon: "🎫",
    },
  ],

  certifications: [
    { name: "CompTIA A+", issuer: "CompTIA", year: "2023", accent: "#00d4ff" },
    { name: "CCNA", issuer: "Cisco", year: "2022", accent: "#7b61ff" },
    { name: "Microsoft MCP", issuer: "Microsoft", year: "2023", accent: "#00e5a0" },
    { name: "ITIL Foundation", issuer: "Axelos", year: "2022", accent: "#ff6b6b" },
  ],
};

// ═══════════════════════════════════════════════════════════════════════════════
// DESIGN TOKENS
// ═══════════════════════════════════════════════════════════════════════════════
export const C = {
  bg:           "#07090f",
  surface:      "#0d1117",
  card:         "#111827",
  cardBorder:   "rgba(255,255,255,0.07)",
  accent:       "#00d4ff",
  accentDim:    "rgba(0,212,255,0.15)",
  accentBorder: "rgba(0,212,255,0.35)",
  violet:       "#7b61ff",
  violetDim:    "rgba(123,97,255,0.15)",
  violetBorder: "rgba(123,97,255,0.35)",
  green:        "#00e5a0",
  text:         "#e2e8f0",
  muted:        "#8892b0",
  faint:        "#3d4663",
  gridLine:     "rgba(0,212,255,0.035)",
  sidebar:      "220px",
};

export const FONT_MONO = "'IBM Plex Mono', 'Fira Code', monospace";
export const FONT_HEAD = "'Syne', 'Outfit', sans-serif";

export const GLOBAL_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=IBM+Plex+Mono:wght@300;400;500&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html { scroll-behavior: smooth; }
  body { background: #07090f; overflow-x: hidden; }
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-track { background: #07090f; }
  ::-webkit-scrollbar-thumb { background: rgba(0,212,255,0.35); border-radius: 4px; }

  @keyframes fadeUp { from { opacity:0; transform:translateY(24px); } to { opacity:1; transform:translateY(0); } }
  @keyframes glow   { 0%,100% { text-shadow: 0 0 16px rgba(0,212,255,0.5); } 50% { text-shadow: 0 0 40px rgba(0,212,255,0.9); } }
  @keyframes float  { 0%,100% { transform:translateY(0); } 50% { transform:translateY(-10px); } }
  @keyframes pulse  { 0%,100% { opacity:1; } 50% { opacity:0.4; } }

  .anim-fadeup { animation: fadeUp 0.6s ease both; }
  .anim-glow   { animation: glow 3.5s ease infinite; }
  .anim-float  { animation: float 5s ease infinite; }

  .card-lift { transition: transform 0.25s ease, border-color 0.25s ease, background 0.25s ease; }
  .card-lift:hover { transform: translateY(-5px); border-color: rgba(0,212,255,0.35) !important; background: #162030 !important; }

  .skill-chip { transition: background 0.2s, color 0.2s, border-color 0.2s; }
  .skill-chip:hover { background: rgba(0,212,255,0.15) !important; color: #00d4ff !important; border-color: rgba(0,212,255,0.35) !important; }

  .nav-btn { background: none; border: none; cursor: pointer; transition: all 0.2s ease; }
  .sidebar-link { transition: all 0.2s ease; }
  .sidebar-link:hover { background: rgba(0,212,255,0.08) !important; color: #00d4ff !important; }

  .contact-row { transition: background 0.2s, border-color 0.2s, transform 0.2s; text-decoration: none; }
  .contact-row:hover { border-color: rgba(0,212,255,0.35) !important; background: #162030 !important; transform: translateX(4px); }

  .cta-primary { transition: box-shadow 0.2s, transform 0.2s; }
  .cta-primary:hover { box-shadow: 0 0 24px rgba(0,212,255,0.5); transform: translateY(-2px); }
  .cta-outline { transition: background 0.2s, transform 0.2s; }
  .cta-outline:hover { background: rgba(0,212,255,0.1) !important; transform: translateY(-2px); }

  @media (max-width: 480px) {
    .contact-row {
      flex-direction: column !important;
      align-items: center !important;
      text-align: center !important;
      gap: 0.4rem !important;
    }
    .contact-label {
      display: flex !important;
      flex-direction: row !important;
      align-items: center !important;
      gap: 0.5rem !important;
      justify-content: center !important;
    }
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 1.3rem !important;
    }
    .anim-fadeup {
      padding-top: 1rem !important;
      padding-left: 1rem !important;
      padding-right: 1rem !important;
    }
    .section-header {
      padding-left: 0 !important;
      margin-left: 0 !important;
    }
    .about-grid {
      grid-template-columns: 1fr !important;
    }
    .about-card {
      min-width: unset !important;
      width: 100% !important;
      order: -1 !important;
    }
  }

  @media (min-width: 1200px) {
  .anim-fadeup {
    max-width: 1100px !important;
    margin-left: auto !important;
    margin-right: auto !important;
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }
}
`;
